export default __webpack_public_path__ + "static/media/inside-optic-installation.a7a16381.svg";